import { type Static, Type } from '@sinclair/typebox';
import type { ArangoDocumentMetadata } from './arango-metadata';

export const ClientEntityMetaDataItemSchema = Type.Object({
  children_type: Type.Optional(Type.String()),
  id: Type.String(),
  name: Type.String(),
});

export const ClientEntityMetaDataSchema = Type.Record(Type.String(), ClientEntityMetaDataItemSchema);
export type ClientEntityMetaData = Static<typeof ClientEntityMetaDataSchema>;

export const ClientEntitiesSelectedOptionSchema = Type.Object({ id: Type.String(), value: Type.String() });
export type ClientEntitiesSelectedOption = Static<typeof ClientEntitiesSelectedOptionSchema>;

export const ClientEntitiesSelectedOptionsSchema = Type.Record(
  Type.String(),
  Type.Array(ClientEntitiesSelectedOptionSchema),
);
export type ClientEntitiesSelectedOptions = Static<typeof ClientEntitiesSelectedOptionsSchema>;

export type ClientEntityDTO = ArangoDocumentMetadata & Record<string, string | string[]>;

// =====================================================================================================================
// List client entities options
// =====================================================================================================================

export const ClientEntityPayloadBodySchema = Type.Optional(Type.Record(Type.String(), Type.Array(Type.String())));
export type ClientEntityPayloadBody = Static<typeof ClientEntityPayloadBodySchema>;
